<script setup lang="ts">
import { Card } from "@/components/ui/card";

const FooterLinks = {
  good: [
    { label: "Home", url: "/", internal: true },
    { label: "About", url: "/#about", internal: true },
    { label: "Help Center", url: "https://help.jittr.app", internal: false },
  ],
  cool: [
    {
      label: "Instagram",
      url: "https://www.instagram.com/jittr.app",
      internal: false,
    },
    { label: "X.com", url: "https://x.com/getjittr", internal: false },
  ],
  boring: [
    {
      label: "Terms of Service",
      url: `${import.meta.env.VITE_HELP_CENTER_URL}/en/legal/terms-of-service`,
      internal: false,
    },
    {
      label: "Privacy Policy",
      url: `${import.meta.env.VITE_HELP_CENTER_URL}/en/legal/privacy-policy`,
      internal: false,
    },
  ],
} as const;

const sections = [
  { title: "The Good", key: "good" },
  { title: "The Cool", key: "cool" },
  { title: "The Boring", key: "boring" },
] as const;
</script>

<template>
  <div
    class="w-full bg-background text-foreground overflow-hidden flex justify-center"
  >
    <Card
      class="max-w-8xl mb-1 bg-background text-neutral-400 pt-40 pb-0 rounded-3xl border-b-0 mx-2 overflow-hidden"
    >
      <div
        class="max-w-5xl mx-auto flex flex-col md:flex-row lg:flex-row justify-between p-2 sm:px-8 sm:py-4 lg:gap-24"
      >
        <!-- Logo -->
        <div class="flex flex-col items-start justify-center gap-4 p-4">
          <img src="https://cdn.jittr.app/logos/logo-white.png" alt="Clipr Logo" class="w-32 h-12 object-cover" />
          <!-- Jittr -->
          <p
            class="text-zinc-400 font-medium mb-4 text-sm tracking-wide px-6 leading-tight"
          >
            Jittr is a global eSIM provider that offers affordable data plans
            for international travel.
          </p>

          <p class="text-zinc-400 font-light tracking-wider mb-4 text-sm px-6">
            © {{ new Date().getFullYear() }} Copyright
          </p>
        </div>

        <!-- Footer Links -->
        <div class="flex items-start justify-center lg:gap-14 gap-8 p-4">
          <div v-for="section in sections" :key="section.key">
            <h3 class="text-white font-medium mb-4 text-sm whitespace-nowrap">
              {{ section.title }}
            </h3>
            <ul class="space-y-3 text-sm">
              <li v-for="link in FooterLinks[section.key]" :key="link.label">
                <router-link
                  v-if="link.internal"
                  :to="link.url"
                  class="hover:text-white transition-colors"
                >
                  {{ link.label }}
                </router-link>
                <a
                  v-else
                  :href="link.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="hover:text-white transition-colors whitespace-nowrap"
                >
                  {{ link.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Bottom Branding -->
      <div
        class="relative flex overflow-hidden w-full lg:-mb-28 md:-mb-8 -mb-6 items-center justify-center bg-gradient-to-b from-white/20 to-background bg-clip-text"
      >
        <div
          class="lg:text-[30rem] px-64 md:text-[20rem] text-[10rem] font-bold leading-none text-neutral-800/30 tracking-[-0.0464em] select-none whitespace-nowrap"
        >
          JITTR
        </div>
      </div>
    </Card>
  </div>
</template>
